(() => {
  const configElement = document.getElementById('OeKlarnaOsmConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('[Ofenerlebnis Klarna] Invalid public OSM configuration.', error);
    return;
  }

  if (!config.clientId) return;

  const placementSelector = '[data-oe-klarna-osm] klarna-placement';
  const sdkSelector = 'script[src^="https://js.klarna.com/web-sdk/v1/klarna.js"]';
  let sdkPromise;

  const sdkIsReady = () => Boolean(window.Klarna?.OnsiteMessaging?.refresh);

  const waitForSdk = (remainingAttempts = 80) => {
    if (sdkIsReady()) return Promise.resolve();
    if (remainingAttempts <= 0) return Promise.reject(new Error('Klarna OSM SDK did not become ready.'));

    return new Promise((resolve) => {
      window.setTimeout(resolve, 50);
    }).then(() => waitForSdk(remainingAttempts - 1));
  };

  const ensureSdk = () => {
    if (sdkIsReady()) return Promise.resolve();
    if (sdkPromise) return sdkPromise;

    let script = document.querySelector(sdkSelector);
    if (!script) {
      script = document.createElement('script');
      script.id = 'klarna-osm-script-tag';
      script.async = true;
      script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
      script.dataset.environment = 'production';
      script.dataset.clientId = config.clientId;
      document.head.appendChild(script);
    }

    sdkPromise = new Promise((resolve, reject) => {
      if (sdkIsReady()) {
        resolve();
        return;
      }

      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', () => reject(new Error('Klarna OSM SDK failed to load.')), { once: true });

      // A script inserted by the legacy app may already have completed loading.
      window.setTimeout(resolve, 0);
    })
      .then(() => waitForSdk())
      .catch((error) => {
        sdkPromise = undefined;
        console.warn('[Ofenerlebnis Klarna] Messaging remains unavailable.', error);
        throw error;
      });

    return sdkPromise;
  };

  const refreshPlacements = () => {
    if (!document.querySelector(placementSelector)) return Promise.resolve();
    return ensureSdk().then(() => window.Klarna.OnsiteMessaging.refresh());
  };

  const setPurchaseAmount = (context, amount) => {
    const normalizedAmount = Number(amount);
    if (!Number.isFinite(normalizedAmount) || normalizedAmount <= 0) return;

    const placements = document.querySelectorAll(`[data-oe-klarna-context="${context}"] klarna-placement`);
    if (!placements.length) return;

    placements.forEach((placement) =>
      placement.setAttribute('data-purchase-amount', String(Math.round(normalizedAmount))),
    );

    if (context === 'cart-drawer' && !document.querySelector('cart-drawer.active')) return;
    refreshPlacements().catch(() => {});
  };

  const activatePagePlacements = () => {
    const pagePlacement = document.querySelector(
      '[data-oe-klarna-context="product"] klarna-placement, [data-oe-klarna-context="cart"] klarna-placement',
    );
    if (pagePlacement) refreshPlacements().catch(() => {});
  };

  const activateCartDrawerPlacement = () => {
    const drawer = document.querySelector('cart-drawer');
    const placement = drawer?.querySelector('[data-oe-klarna-context="cart-drawer"] klarna-placement');
    if (!drawer?.classList.contains('active') || !placement || placement.dataset.oeKlarnaActivated === 'true') return;

    placement.dataset.oeKlarnaActivated = 'true';
    refreshPlacements().catch(() => {});
  };

  const observeCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const observer = new MutationObserver(activateCartDrawerPlacement);
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
  };

  document.addEventListener(
    'oe:product-price-change',
    (event) => {
      if (event.target.matches?.('product-upsell[data-quantity-pricing="true"]')) {
        setPurchaseAmount('product', event.detail.amount);
      }
    },
  );

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      activatePagePlacements();
      const quantityPrice = document.querySelector('product-upsell[data-quantity-pricing="true"]')?.dataset.displayedPrice;
      if (quantityPrice) setPurchaseAmount('product', quantityPrice);
      observeCartDrawer();

      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object') return;

      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (document.querySelector('product-upsell[data-quantity-pricing="true"]')) return;
        setPurchaseAmount('product', event?.data?.variant?.price);
      });

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const total = event?.cartData?.total_price;
        setPurchaseAmount('cart', total);
        setPurchaseAmount('cart-drawer', total);
      });
    },
    { once: true },
  );
})();
